<div class="bg-grey-lightest mb-4 p-2 rounded-sm text-sm">
	Note: Clients will receive Treefort’s IDV request via email. Cell phone
	numbers are required for two-factor authentication (2FA) as an added security
	measure to protect the client’s sensitive information.
</div>

<form [formGroup]="profileForm" (submit)="onSubmit()">
	<table class="send-idv-table table-auto w-full text-left text-sm mb-4">
		<thead>
			<tr>
				<th>Client Name</th>
				<th class="pl-3">
					<app-icon class="mr-4" [icon]="ICON.PHONE"></app-icon
					><span>Cell Phone*</span>
				</th>
				<th class="pl-3">
					<app-icon class="mr-4" [icon]="ICON.EMAIL"></app-icon>
					<span>Email*</span>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				formArrayName="profiles"
				*ngFor="let profile of profiles.controls; index as i"
			>
				<td>
					<div class="flex gap-x-3">
						<atomic-name-badge
							[name]="profile.controls.Name.value"
							size="xsmall"
							[testHook]="testHooks.ProfileControlsNameValueNameBadge"
						></atomic-name-badge>
						<span>{{ profile.controls.Name.value }}</span>
					</div>
				</td>
				<td formGroupName="{{ i }}" class="max-w-[11.25rem]">
					<div class="flex">
						<app-input
							class="max-w-[3.75rem] mr-2"
							type="tel"
							formControlName="DialCode"
							[inputWidth]="'3.75rem'"
							[placeholder]="'+1'"
							[textAlign]="'right'"
							[testHook]="testHooks.DialCode"
						></app-input>
						<app-input
							type="tel"
							formControlName="PhoneNumber"
							[testHook]="testHooks.PhoneNumber"
						></app-input>
					</div>
				</td>
				<td formGroupName="{{ i }}">
					<div class="flex">
						<app-input
							type="email"
							formControlName="Email"
							[testHook]="testHooks.Email"
						></app-input>
					</div>
				</td>
			</tr>
		</tbody>
	</table>

	<div class="bg-grey-lightest rounded-sm px-3 py-6 text-sm">
		<button
			[attr.aria-expanded]="isExpanded"
			[attr.aria-label]="isExpanded ? expandedAriaLabel : collapsedAriaLabel"
			aria-controls="treefort-verification-controls"
			(click)="toggleTreefortSettingsExpansion($event)"
			type="button"
			class="treefort-settings-button"
			[testHook]="testHooks.IdentityVerificationSettingsButton"
		>
			Identity Verification Settings
			<app-icon
				class="w-4 ml-1"
				[icon]="isExpanded ? ICON.UP : ICON.DOWN"
			></app-icon>
		</button>

		<div
			id="treefort-verification-controls"
			*ngIf="isExpanded && isTreefortConnected"
			[@openClose]
		>
			<app-input-wrapper
				label="Requires secondary ID"
				class="w-[unset]"
				[testHook]="testHooks.RequiresSecondaryIdInputWrapper"
			>
				<atomic-switch
					formControlName="secondaryIdRequired"
					[testHook]="testHooks.SecondaryIdRequiredSwitch"
				></atomic-switch>
			</app-input-wrapper>
			<app-input-wrapper
				label="Requires financial institution login"
				class="w-[unset]"
				[testHook]="testHooks.RequiresFinancialInstitutionLoginInputWrapper"
			>
				<atomic-switch
					formControlName="financialInstitutionLoginRequired"
					[testHook]="testHooks.FinancialInstitutionLoginRequiredSwitch"
				></atomic-switch>
			</app-input-wrapper>
			<app-input-wrapper
				label="Requires advanced AML screening"
				class="w-[unset]"
				[testHook]="testHooks.RequiresAdvancedAmlScreeningInputWrapper"
			>
				<atomic-switch
					formControlName="advancedAMLScreeningRequired"
					[testHook]="testHooks.AdvancedAmlscreeningRequiredSwitch"
				></atomic-switch>
			</app-input-wrapper>
		</div>
	</div>

	<div class="line-break mt-4"></div>

	<div class="flex justify-between mt-12 mx-5">
		<app-button
			size="small"
			btn="border"
			(onClick)="onBackHandler()"
			[testHook]="testHooks.BackButton"
			>Back</app-button
		>
		<app-button
			size="small"
			[loading]="isSending"
			type="submit"
			[testHook]="testHooks.SendButton"
			>Send</app-button
		>
	</div>
</form>
